export default __webpack_public_path__ + "static/media/ellipsis-vertical.2f15164d.svg";